import { checkIsInStock, checkPrices, getPriceStatus, renderDefaultPrices, renderDiscountPrices, renderRebateAndDiscountPrices, renderRebatePrices } from "./functions";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { isPriceVisible } from "../../helpers/product";
import "./prices.scss";
import { getWholesalePriceSummary } from "./priceContent";

export const Prices = ({ price, inventory, selectedProduct, behaviours, useTemplate = false }) => {
    const { t } = useTranslation();

    // Price display is disabled for product
    if (!isPriceVisible(behaviours)) {
        return <p className={`w-100 text-black p-2 rounded-3 mt-3 `}>{t("global-default-text-price_on_request", "Cena na upit")}</p>;
    }

    let status = getPriceStatus(price);
    let is_in_stock = checkIsInStock(inventory);
    let prices = checkPrices(price);

    let data = {
        status: status,
        is_in_stock: is_in_stock,
        price_defined: prices?.price_defined,
        is_price_range: selectedProduct ? false : prices?.price_range,
        price: price,
    };

    // Product details: price display rendered by the API (default display or patterns entered in configuration).
    // Checked before the missing price guard, because configuration can define the text for a product without a price.
    if (useTemplate && price?.content?.html) {
        const summary = getWholesalePriceSummary(price.content.html);
        const content = <div className={`product-details-price-box`}>{summary ? (
            <div className="product-price-summary">
                <span className="product-details-price-label">VP cena</span>
                <div className="product-price-summary-top">
                    <span className="product-price-summary-regular">{summary.wholesale}</span>
                    <span className="product-price-summary-rebate">Rabat {summary.rebate}</span>
                </div>
                <div className="product-price-summary-final">
                    <span className="product-details-price-label">Neto cena sa rabatom</span>
                    <strong>{summary.net}</strong>
                </div>
            </div>
        ) : parse(price.content.html, {
            replace: (node) => {
                if (node.type !== "text" || !/^\s*VP\s+cena\s*:?/i.test(node.data)) return;
                const amount = node.data.replace(/^\s*VP\s+cena\s*:?\s*/i, "");
                return <><span className="product-details-price-label">VP cena</span>{amount}</>;
            },
        })}</div>;

        if (!price?.content?.tooltip_html) {
            return content;
        }

        return (
            <Tooltip placement={"top"} arrow={true} title={<Box>{parse(price.content.tooltip_html)}</Box>}>
                {content}
            </Tooltip>
        );
    }

    if (!data.price_defined && selectedProduct) {
        return <p className={`w-100 text-black p-2 rounded-3 mt-3 `}>{t("global-default-text-send_inquiry")}</p>;
    }

    switch (data?.status) {
        case "default":
            return renderDefaultPrices({ ...data });
        case "discount":
            return renderDiscountPrices({ ...data });
        case "rebates":
            return renderRebatePrices({ ...data });
        case "discount_rebates":
            return renderRebateAndDiscountPrices({ ...data });
    }
};
